export default __webpack_public_path__ + "static/media/Product Icon.e1dc098d.svg";